<template>
  <b-card>
    
    <Breadcrumb :title="`Inventario - ${getTitleSectionByLink(this.$route.params.active)}`"/>

    <Header />

    <div class="mt-2">
      <sections v-if="this.$route.params.active === 'sections'" />
      <colums v-if="this.$route.params.active === 'columns'" />
      <inventory-sections v-if="this.$route.params.active === 'inventory-sections'" />
    </div>
    
  </b-card>
</template>
<script>

// Generales
import { mapMutations } from "vuex";

// Componentes
import sections from "./Sections/Index.vue";
import colums from "./Colums/Index.vue";
import inventorySections from "./InventorySections/Index.vue";
import Breadcrumb from "./components/Breadcrumb.vue";
import Header from "./components/Header.vue";

// Mixins
import IndexMixin from "../../servicios/inventory/mixins/sections/index"

export default {

  name: 'InventoryIndex',

  components: {
    sections,
    colums,
    inventorySections,
    Breadcrumb,
    Header
  },

  mixins: [IndexMixin],

  mounted() {
    this.load(true);
  },

  data() {
    return {
      active: this.$route.params.active,
    };
  },

  methods: {

    ...mapMutations("dashboard", ["load"]),
    
    nav(active) {
      this.active = active;
    }
    
  }

};

</script>
